import { render, staticRenderFns } from "./CustomerHome.vue?vue&type=template&id=46caeb18&scoped=true&"
import script from "./CustomerHome.vue?vue&type=script&lang=js&"
export * from "./CustomerHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46caeb18",
  null
  
)

export default component.exports